


























import _ from "lodash";
import { Component, Prop, Mixins } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";

@Component
export default class EditSaveProduct extends Mixins(AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;

  get editSave() {
    return this.$store.state.product.editSave;
  }
  
  edit() {
    this.$emit('on-confirm-save')
    this.$emit("input", false);
  }

  cancel() {
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}
